<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          id="prompt-name"
          v-model="node.name"
          label="Name"
          dense
          hide-details
        >
        </v-text-field>
      </v-col>
    </v-row>

    <div class="m-t-15">
      <v-switch
        v-model="property.config.is_customize_input"
        label="Custom setting"
        inset
        dense
        x-small
        hide-details
      ></v-switch>

      <div v-if="property.config.is_customize_input" class="m-t-15">
        <config-nlu :defaultInput="property.config.default_input"></config-nlu>
      </div>

      <div class="m-t-15" v-if="property.config.is_customize_input">
        <div class="input-title">Input</div>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
            <v-checkbox
              v-model="property.config.setting.is_count_retry"
              label="+1 retry if there is no input"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="p-t-0 p-b-0" cols="12" sm="7" lg="7">
            <span class="p-l-50">Max input timeout</span>
          </v-col>
          <v-col class="d-flex p-t-0 p-b-0" cols="12" sm="5" lg="5">
            <div>
              <v-text-field
                type="number"
                v-model="property.config.setting.max_input_timeout"
                class="margin0 padding0 width50px"
                min="5"
                step="5"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="ml-2">minutes</div>
          </v-col>
        </v-row>
      </div>
    </div>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
import ConfigNlu from '../../voice/start/components/config_nlu'

export default {
  props: {
    node: Object
  },
  components: {
    NoteComponent,
    ConfigNlu
  },
  data() {
    return {
      property: {}
    }
  },
  async created() {
    if (!this.node.property.config.default_input) {
      this.node.property.config.default_input = {
        is_count_retry: false,
        nlu: ''
      }
    }
    if (!this.node.property.config.default_input.is_count_retry) {
      this.node.property.config.default_input.is_count_retry = false
    }
    if (!this.node.property.config.default_input.nlu) {
      this.node.property.config.default_input.nlu = ''
    }

    this.property = this.node.property
  },
  methods: {}
}
</script>
